import { Dimension } from 'src/@enums'
import { gaEvent, getDimensionByUnit } from 'src/utils'

/**
 * [TARGET]: registrar o slug da RE
 *
 * [CONTEXTO]: utilizado nos eventos para registro do catalog slug da RE
 *
 * [REGRAS]: n/a
 *
 * @param slug - Texto que identifica o slug da RE
 */
export const slugEvent = (slug: string) => {
  gaEvent({ [getDimensionByUnit(Dimension.RESELLER_SLUG)]: slug })
}
